import AppUtils from "../../../../Utils/utils"
import { formatCount, formatRate, PROGRAMS } from "./programLimits"

const compact = (value) => AppUtils.convertNumber(Number(value ?? 0), 1)


const METRICS = {
  chargebacks: { icon: "bh_metric_chargeback", label: "Chargebacks" },
  payments: { icon: "bh_metric_payment", label: "Payments" },
  volume: { icon: "bh_metric_volume", label: "Volume" },
  threeDs: { icon: "bh_metric_three_ds", label: "3DS usage" }
}

const PROGRAM_LINES = {
  [PROGRAMS.VAMP]: {
    rate: (month) => formatRate(month?.vamp_rate),
    metrics: [
      { key: "chargebacks", value: (month) => formatCount(month?.vamp_count) },
      { key: "payments", value: (month) => compact(month?.transaction_count) }
    ]
  },
  [PROGRAMS.ECP]: {
    rate: (month) => formatRate(month?.chargeback_rate),
    metrics: [
      { key: "chargebacks", value: (month) => formatCount(month?.chargeback_count) },
      { key: "payments", value: (month) => compact(month?.transaction_count) }
    ]
  },
  [PROGRAMS.EFM]: {
    rate: (month) => formatRate(month?.fraud_rate),
    metrics: [
      { key: "volume", value: (month) => formatCount(month?.net_fraud_volume) },
      { key: "threeDs", value: (month) => formatRate(month?.three_ds_usage_rate) }
    ]
  }
}

export const getMonthCellLines = ({ program, month }) => {
  const config = PROGRAM_LINES[program]

  return [
    { key: "rate", value: config.rate(month) },
    ...config.metrics.map(({ key, value }) => ({ key, value: value(month), ...METRICS[key] }))
  ]
}

export const getMetricLegend = (program) =>
  PROGRAM_LINES[program].metrics.map(({ key }) => ({ key, ...METRICS[key] }))
